/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import {isEmpty, Status, subscribe, getConfig, showModal, getBrand, openWindow, getOwaTcdaoContext} from '../twd'
import { getHoldings } from './get-holdings'
import { getBondInfo } from './get-bond-info'
import { getCalcInput, isCalcInput } from './get-calc-input'
import { getCalcOutput } from './get-calc-output'

export const STEPS = {
    INIT: 'init',
    INIT_LOADING: 'init-loading',
    INIT_ERROR: 'init-error',
    CUSIP_INPUT: 'cusip-input',
    CUSIP_LOADING: 'cusip-loading',
    CUSIP_ERROR: 'cusip-error',
    CALC_INPUT: 'calc-input',
    CALC_LOADING: 'calc-loading',
    CALC_ERROR: 'calc-error',
    CALC_OUTPUT: 'calc-output',
    UNKNOWN: 'unknown',
}

subscribe('calculator.calculator', (args) => {

    if (getConfig('entitlements.ETradeCalculator', 'No') === 'Yes') {
        showModal({
            view: 'calculator',
            ...(args||{})
        })
        return
    }

    let base = getConfig('bw_service_host') + '/' + getBrand()
    let owaTcDaoContext = getOwaTcdaoContext()
    let url = `${base}/${owaTcDaoContext}/pkg_calc_bond_online.seed?p_javascript=2&p_id=null&p_data_source=I`
    let name = 'calculator'
    let options = 'toolbar=no,width=800,height=600,directories=no,status=no,scrollbars=no,resizable=yes,menubar=no'
    openWindow(url, name, options)
})

const useContext = (args={}) => {

    const [step, setStep] = React.useState(STEPS.INIT)
    const [status, setStatus] = React.useState(Status.NULL)
    const [cusip, setCusip] = React.useState(args.cusip || null)
    const [holdings, setHoldings] = React.useState([])
    const [bondInfo, setBondInfo] = React.useState(null)
    const [calcInput, setCalcInput] = React.useState(getCalcInput(args))
    const [calcOutput, setCalcOutput] = React.useState(null)
    const [showCoupon, setShowCoupon] = React.useState(args.showCoupon)

    React.useEffect(() => {(async () => {
        setStep(STEPS.INIT)

        let holdingArray = holdings
        if (isEmpty(holdingArray)) {
            try {
                setStep(STEPS.INIT_LOADING)
                holdingArray = await getHoldings()
                setHoldings(holdingArray)
                if (isEmpty(cusip)) {
                    setStep(STEPS.CUSIP_INPUT)
                    return
                }
            } catch(e) {
                setStep(STEPS.INIT_ERROR)
                return
            }
        }

        if (isEmpty(cusip)) {
            setStep(STEPS.CUSIP_INPUT)
            return
        }

        if (step===STEPS.INIT_LOADING) {
            return
        }

        if (!isEmpty(cusip) && isEmpty(bondInfo)) {
            try {
                setStep(STEPS.CUSIP_LOADING)
                const bi = await getBondInfo({cusip, holdings:holdingArray})
                setBondInfo(bi)

                if (calcInput && !calcInput.settlement) {
                    calcInput.settlement = bi.settlement
                    setCalcInput({...calcInput})
                }
                if (!isCalcInput(bi, calcInput)) {
                    setStep(STEPS.CALC_INPUT)
                    return
                }

            } catch(e) {
                console.error('cusip-error', e)
                setStep(STEPS.CUSIP_ERROR)
                return
            }
        }

        if (!isCalcInput(bondInfo, calcInput)) {
            setStep(STEPS.CALC_INPUT)
            return
        }

        if (step===STEPS.CUSIP_LOADING) {
            return
        }

        if (!isEmpty(calcInput) && isCalcInput(bondInfo, calcInput) && isEmpty(calcOutput)) {
            try {
                setStep(STEPS.CALC_LOADING)
                const calc = await getCalcOutput({
                    cusip,
                    ...calcInput
                })

                if (calc && !isEmpty(calc.error)) {
                    throw calc.error
                }

                setCalcOutput(calc)
                setShowCoupon(true)
                setStep(STEPS.CALC_OUTPUT)
                return
            } catch(e) {
                console.error('calc-error', e)
                setStep(STEPS.CALC_ERROR)
                return
            }
        }

        setStep(STEPS.UNKNOWN)

    })()}, [cusip, calcInput])

    const changeCusip = () => {
        setBondInfo(null)
        setCalcOutput(null)
        setCusip('')
        setShowCoupon(false)
    }

    const resetCalc = () => {
        setCalcOutput(null)
        setStep(STEPS.CALC_INPUT)
    }

    return {
        step, setStep,
        status, setStatus,
        cusip, setCusip,
        showCoupon,
        holdings,
        bondInfo, setBondInfo,
        calcInput, setCalcInput,
        calcOutput, setCalcOutput,
        changeCusip,
        resetCalc,
        from_: args.from
    }
}


export const Context = React.createContext()
export const ContextProvider = ({children,...args}) => {
    const ctx = useContext(args)
    return <Context.Provider value={ctx}>{children}</Context.Provider>
}
export const useCalculator = () => React.useContext(Context)